import qs from 'querystring';
import VrsFetcher from './VrsFetcher.js';
import getPath from '../../fetchers/utils/getPath.js';
const requiredParams = {
  makes: ['yearId'],
  models: ['yearId', 'makeId'],
  trims: ['yearId', 'makeId', 'modelId'],
  vehicles: ['yearId', 'makeId', 'modelId', 'trimId']
};

/**
 * Client class to integrate the the KBB VRS services into ATC applications
 * @module VrsService
 */
class VrsService {
  /**
   * constructor for the KBB VRS Service client
   */
  constructor() {
    let {
      environment = 'staging'
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.fetcher = new VrsFetcher(getPath(environment));
  }
  _getVrsData(endpoint) {
    let query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const requiredKeys = requiredParams[endpoint.replace('/', '')];
    const missingValues = [];

    // Ensures all of the required fields are present before doing the fetch
    const hasRequiredParams = requiredKeys.reduce((acc, key) => {
      if (!query[key]) {
        missingValues.push(key);
        return false;
      }
      return acc;
    }, true);
    if (hasRequiredParams) {
      const querystring = qs.stringify({
        ...query,
        limit: 100
      });
      return this.fetcher.fetch(`/data${endpoint}?${querystring}`);
    }

    // eslint-disable-next-line no-console
    console.error(`[VrsDataFetcher] - ${missingValues.join(', ')} parameters are all required for vrs endpoint /${endpoint}`);
    return null;
  }

  /**
   * @alias module:VrsService
   * @returns {Promise<*>}
   */
  async getYears() {
    return this.fetcher.fetch('/data/years?limit=100&applicationFilter=Consumer&vehicleClass=UsedCar');
  }

  /**
   * @alias module:VrsService
   * @param query
   * @returns {Promise<*>}
   */
  async getMakes(query) {
    return this._getVrsData('/makes', query);
  }

  /**
   * @alias module:VrsService
   * @param query
   * @returns {Promise<*>}
   */
  async getModels(query) {
    return this._getVrsData('/models', query);
  }

  /**
   * @alias module:VrsService
   * @param query
   * @returns {Promise<*>}
   */
  async getTrims(query) {
    return this._getVrsData('/trims', query);
  }

  /**
   * @alias module:VrsService
   * @param query
   * @returns {Promise<*>}
   */
  async getVehicleId(query) {
    return this._getVrsData('/vehicles', query);
  }

  /**
   * @alias module:VrsService
   * @param kbbVehicleId
   * @returns {Promise<*>}
   */
  async getDetailsById(kbbVehicleId) {
    return this.fetcher.fetch(`/data/vehicles/id/${kbbVehicleId}`);
  }

  /**
   * @alias module:VrsService
   * @param body
   * @returns {Promise<*>}
   */
  async getVehicleValuation(body) {
    return this.fetcher.fetch('/valuation/values', {
      method: 'POST',
      body
    });
  }

  /**
   * @alias module:VrsService
   * @param kbbVehicleId
   * @returns {Promise<*>}
   */
  async getConsumerRatings(kbbVehicleId) {
    return this.fetcher.fetch(`/editorial/consumerratings/id/${kbbVehicleId}`);
  }
}
export { VrsService as default };
